export function setRoot(html: string) {
  const app = document.getElementById("app");
  if (app) app.innerHTML = html;
}

export function showError(message: string) {
  const banner = document.createElement("div");
  banner.className = "fixed top-2 left-2 right-2 bg-red-100 text-red-800 p-3 rounded shadow z-50";
  banner.textContent = message;
  document.body.appendChild(banner);
  setTimeout(() => banner.remove(), 4000);
}

export function pad2(n: number): string {
  return String(n).padStart(2, "0");
}
